
import Colorfilter from "../../../assets/outline/Colorfilter.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ColorfilterIcon({ className, dataTestid = "ColorfilterIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Colorfilter data-testid={dataTestid} className={classes} {...rest} />
  );
}
